export const motionTokens = {
  duration: {
    fast: 0.2,
    normal: 0.5,
    slow: 1,
  },
  distance: {
    small: 16,
    medium: 40,
  },
  scale: {
    hover: 1.03,
    cinematic: 1.05,
  },
  delay: {
    secondary: 0.125,
    stagger: 0.075,
  },
  ease: {
    entrance: 'power3.out',
    exit: 'power2.in',
    standard: 'power2.out',
  },
} as const
